import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const quickLinks = [
    { to: '/', label: t('首页') },
    { to: '/category/action', label: t('分类') },
    { to: '/about', label: t('关于我们') },
    { to: '/about', label: t('商务合作') },
  ];

  const categories = [
    { to: '/category/action', label: t('热血') },
    { to: '/category/fantasy', label: t('奇幻') },
    { to: '/category/romance', label: t('恋爱') },
    { to: '/category/comedy', label: t('搞笑') },
  ];

  const helpLinks = [
    { to: '/about', label: t('常见问题') },
    { to: '/about', label: t('意见反馈') },
    { to: '/about', label: t('用户协议') },
    { to: '/about', label: t('隐私政策') },
  ];

  const siteLinks = [
    { icon: 'ri-home-4-line', label: t('首页'), to: '/' },
    { icon: 'ri-fire-line', label: t('热血'), to: '/category/action' },
    { icon: 'ri-magic-line', label: t('奇幻'), to: '/category/fantasy' },
    { icon: 'ri-information-line', label: t('关于我们'), to: '/about' },
  ];

  return (
    <footer className="bg-background-200/70 border-t border-background-300/60">
      <div className="px-4 md:px-6 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div>
            <h4 className="text-foreground-900 font-heading text-base mb-4">{t('快速链接')}</h4>
            <div className="w-8 h-px bg-primary-500 mb-4"></div>
            <ul className="flex flex-col gap-2.5">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-900 font-heading text-base mb-4">{t('热门分类')}</h4>
            <div className="w-8 h-px bg-accent-500 mb-4"></div>
            <ul className="flex flex-col gap-2.5">
              {categories.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-900 font-heading text-base mb-4">{t('帮助中心')}</h4>
            <div className="w-8 h-px bg-secondary-500 mb-4"></div>
            <ul className="flex flex-col gap-2.5">
              {helpLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-900 font-heading text-base mb-4">{t('关注我们')}</h4>
            <div className="w-8 h-px bg-primary-500 mb-4"></div>
            <div className="flex items-center gap-3 flex-wrap">
              {siteLinks.map((link) => (
                <Link
                  key={link.label}
                  to={link.to}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 hover:bg-primary-500 hover:text-white text-foreground-600 transition-all cursor-pointer"
                  title={link.label}
                >
                  <i className={`${link.icon} text-base`}></i>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-300/60">
        <div className="px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex flex-col items-center sm:items-start gap-1">
            <span className="font-heading text-2xl text-foreground-900">{t('网站名称')}</span>
            <div className="w-12 h-px bg-primary-500/60 my-1"></div>
            <p className="text-xs text-foreground-500">{t('免费动漫随时追番')}</p>
          </div>
          <p className="text-xs text-foreground-500 whitespace-nowrap">{t('版权信息')}</p>
        </div>
      </div>
    </footer>
  );
}
